import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Wrapper from '../assets/wrappers/ViewUserModal';
import profile from '../assets/images/profile.jpg';

const ViewNewsModal = ({ show, setShow, data }) => {
  const { title, topic, topic_title, overview, description } =
    data;
  const handleClose = () => {
    setShow(false);
  };
  // const adjustedDate = new Date(date.seconds * 1000 + date.nanoseconds / 1000000);
  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={true}
      size='lg'
      dialogClassName='View More Modal'
      // aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Wrapper>
        <Modal.Header className='modalHeader' closeButton>

        </Modal.Header>
        <Modal.Body>
          <div className=''>

            <div className='mb-3'>
              <h4 className='mb-0'>title</h4>
              <span>{title}</span>
            </div>
            <div className='mb-3'>
              <h4 className='mb-0'>topic</h4>
              <span>{topic}</span>
            </div>
            <div className='mb-3'>
              <span>
                <h4 className='mb-0'>topic title</h4>
                <span>{topic_title}</span>
              </span>
            </div>
            <div className='mb-3'>
              <h4 className='mb-0'>overview</h4>
              <span>{overview}</span>
            </div>
            <div className='mb-3'>
              <h4 className='mb-0'>description</h4>
              <span>{description}</span>
            </div>
          </div>
        </Modal.Body>
      </Wrapper>
    </Modal>
  );
};

export default ViewNewsModal;
